import SignupComp from "../../component/Signup";

const SignUp = () => {
  return (
    <>
      <SignupComp />
    </>
  );
};
export default SignUp;
